import { Injectable } from '@angular/core';
import { PubnubService } from './Pubnub.service';
import { environment } from './../../environments/environment.prod';
import { Observable,throwError } from 'rxjs';
import { catchError, delay } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})

export class UtiltityService {
    public valleyFairPark = {
        "type": "FeatureCollection",
        "name": "sql_statement",
        "units": "m",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        "features": [
            { "type": "Feature", "properties": { "id": 0, "ground_altitude_hae": 0, "height_m": 10.0584, "main": true, "floors": [{ "altitude": 0.3048 }, { "altitude": 3.3528 }, { "altitude": 6.7056 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-121.94947506465985, 37.326504366594492], [-121.949469653088613, 37.325660161482489], [-121.947824535434464, 37.325689925124259], [-121.947369963451081, 37.326049794611102], [-121.947367257665462, 37.326174260749411], [-121.947353728737383, 37.326176966535023], [-121.947356434523002, 37.326290609530872], [-121.947369963451081, 37.326306844244563], [-121.947378080807923, 37.326523307093794], [-121.94947506465985, 37.326504366594492]]] } }
        ]
    }
    public embassy = {
        "type": "FeatureCollection", "units": "m",
        "features": [
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9786751, 37.3842113], [-121.9783647, 37.3842102], [-121.9783651, 37.3840992], [-121.9783655, 37.3839971], [-121.9783414, 37.383997], [-121.9783429, 37.3835946], [-121.9786305, 37.3835957], [-121.9786305, 37.3836732], [-121.9786294, 37.3839123], [-121.9786367, 37.3839123], [-121.978636, 37.3839998], [-121.9786759, 37.3839999], [-121.9786757, 37.3840654], [-121.9786751, 37.3842113]], [[-121.9784841, 37.383793], [-121.9784841, 37.3837603], [-121.9784112, 37.3837596], [-121.9784105, 37.3837924], [-121.9784841, 37.383793]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": true, "height_m": 33.03875952, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 39, "altitude": 0.00 }, { "name": "FLR02", "id": 40, "altitude": 6.20 }, { "name": "FLR03", "id": 41, "altitude": 9.30 }, { "name": "FLR04", "id": 42, "altitude": 11.90 }, { "name": "FLR05", "id": 43, "altitude": 14.50 }, { "name": "FLR06", "id": 44, "altitude": 17.10 }, { "name": "FLR07", "id": 45, "altitude": 19.70 }, { "name": "FLR08", "id": 46, "altitude": 22.30 }, { "name": "FLR09", "id": 47, "altitude": 24.90 }, { "name": "FLR10", "id": 48, "altitude": 27.50 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9783625, 37.3842102], [-121.9782837, 37.3842099], [-121.9782841, 37.3840989], [-121.9783629, 37.3840992], [-121.9783625, 37.3842102]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 4.77767904, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 38, "altitude": 0.00 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9786915, 37.3837829], [-121.9788616, 37.3837835], [-121.9788611, 37.3839117], [-121.9786906, 37.3839108], [-121.9786915, 37.3837829]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 6.86467512, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 37, "altitude": 0.00 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9786749, 37.3842082], [-121.9786771, 37.3840843], [-121.9786814, 37.3840817], [-121.9786814, 37.3842091], [-121.9786749, 37.3842082]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 6, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 36, "altitude": 0.00 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9786869, 37.3839191], [-121.9786316, 37.38392], [-121.9786327, 37.3836687], [-121.9786891, 37.3836687], [-121.9786869, 37.3839191]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 11.6, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 35, "altitude": 0.00 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9787101, 37.3840254], [-121.9786382, 37.3840272], [-121.9786371, 37.3839174], [-121.9787101, 37.38392], [-121.9787101, 37.3840254]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 33, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 25, "altitude": 0.00 }, { "name": "FLR02", "id": 26, "altitude": 6.20 }, { "name": "FLR03", "id": 27, "altitude": 9.30 }, { "name": "FLR04", "id": 28, "altitude": 11.90 }, { "name": "FLR05", "id": 29, "altitude": 14.50 }, { "name": "FLR06", "id": 30, "altitude": 17.10 }, { "name": "FLR07", "id": 31, "altitude": 19.70 }, { "name": "FLR08", "id": 32, "altitude": 22.30 }, { "name": "FLR09", "id": 33, "altitude": 24.90 }, { "name": "FLR10", "id": 34, "altitude": 27.50 }] } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-121.9786818, 37.3840281], [-121.9786818, 37.3840826], [-121.9786775, 37.3840817], [-121.9786775, 37.3840281], [-121.9786818, 37.3840281]]] }, "properties": { "ubid": 1, "name": "EmbassySuites", "street": "LAKESIDE", "street_type": "DR", "from_st": 2885, "to_st": 2885, "main": false, "height_m": 6, "ground_altitude_hae": 0, "building": 4, "floors": [{ "name": "FLR01", "id": 24, "altitude": 0.00 }] } }]
    }
    public embarcadero = {
        "type": "FeatureCollection",
        "name": "sql_statement",
        "units": "ft",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        "features": [
            {
                "type": "Feature", "properties": {
                    "id": 1, "ground_altitude_hae": 0, "height_m": 352, "floors": [{ "altitude": 1 }, { "altitude": 14 }, { "altitude": 27 }, { "altitude": 40 }, { "altitude": 53 }, { "altitude": 66 }, { "altitude": 79 }, { "altitude": 92 }, { "altitude": 105 }, { "altitude": 118 }, { "altitude": 131 }, { "altitude": 144 }, { "altitude": 157 }, { "altitude": 170 }, { "altitude": 183 }, { "altitude": 196 }, { "altitude": 209 }, { "altitude": 222 }, { "altitude": 235 }, { "altitude": 248 }, { "altitude": 261 }, { "altitude": 274 }, { "altitude": 287 }, { "altitude": 300 }, { "altitude": 313 }, { "altitude": 326 }, { "altitude": 339 }]
                }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.398042, 37.794919], [-122.398218, 37.794897], [-122.398784, 37.794829], [-122.398791, 37.794864], [-122.398851, 37.794857], [-122.39886, 37.794904], [-122.398108, 37.794995], [-122.398058, 37.795001], [-122.398042, 37.794919]]] }
            },

            {
                "type": "Feature", "properties": {
                    "id": 2, "ground_altitude_hae": 0, "height_m": 391, "main": true, "floors": [{ "altitude": 1 }, { "altitude": 14 }, { "altitude": 27 }, { "altitude": 40 }, { "altitude": 53 }, { "altitude": 66 }, { "altitude": 79 }, { "altitude": 92 }, { "altitude": 105 }, { "altitude": 118 }, { "altitude": 131 }, { "altitude": 144 }, { "altitude": 157 }, { "altitude": 170 }, { "altitude": 183 }, { "altitude": 196 }, { "altitude": 209 }, { "altitude": 222 }, { "altitude": 235 }, { "altitude": 248 }, { "altitude": 261 }, { "altitude": 274 }, { "altitude": 287 }, { "altitude": 300 }, { "altitude": 313 }, { "altitude": 326 }, { "altitude": 339 }, { "altitude": 352 }, { "altitude": 365 }, { "altitude": 378 },
                    ]
                }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.39886, 37.794904], [-122.398891, 37.7949], [-122.398902, 37.794958], [-122.398946, 37.794953], [-122.398954, 37.794996], [-122.398127, 37.795096], [-122.398119, 37.795055], [-122.398108, 37.794995], [-122.39886, 37.794904]]] }
            },

            {
                "type": "Feature", "properties": {
                    "id": 3, "ground_altitude_hae": 0, "height_m": 352, "floors": [{ "altitude": 1 }, { "altitude": 14 }, { "altitude": 27 }, { "altitude": 40 }, { "altitude": 53 }, { "altitude": 66 }, { "altitude": 79 }, { "altitude": 92 }, { "altitude": 105 }, { "altitude": 118 }, { "altitude": 131 }, { "altitude": 144 }, { "altitude": 157 }, { "altitude": 170 }, { "altitude": 183 }, { "altitude": 196 }, { "altitude": 209 }, { "altitude": 222 }, { "altitude": 235 }, { "altitude": 248 }, { "altitude": 261 }, { "altitude": 274 }, { "altitude": 287 }, { "altitude": 300 }, { "altitude": 313 }, { "altitude": 326 }, { "altitude": 339 },
                    ]
                }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.398127, 37.795096], [-122.398954, 37.794996], [-122.398962, 37.79504], [-122.398908, 37.795046], [-122.398921, 37.795112], [-122.398521, 37.79516], [-122.398466, 37.795166], [-122.398098, 37.795211], [-122.398077, 37.795102], [-122.398127, 37.795096]]] }
            }

        ]
    }

    public nema = {
        "type": "FeatureCollection",
        "name": "sql_statement",
        "units": "ft",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        "features": [
            {
                "type": "Feature", "properties": {
                    "id": 1, "ground_altitude_hae": 0, "height_m": 276, "main": true, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }, { "altitude": 155 }, { "altitude": 166 }, { "altitude": 177 }, { "altitude": 188 }, { "altitude": 199 }, { "altitude": 210 }, { "altitude": 221 }, { "altitude": 232 }, { "altitude": 243 }, { "altitude": 254 }, { "altitude": 265 },
                    ]
                }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.417148165531714, 37.775520306750138], [-122.416816286910944, 37.775786807030897], [-122.416736688213234, 37.775716392798309], [-122.416761531689616, 37.775691461344984], [-122.41677954905046, 37.775704146844809], [-122.417055083004072, 37.775451574054003], [-122.417148165531714, 37.775520306750138]]] },
            }, { "type": "Feature", "properties": { "id": 2, "ground_altitude_hae": 0, "height_m": 254, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }, { "altitude": 155 }, { "altitude": 166 }, { "altitude": 177 }, { "altitude": 188 }, { "altitude": 199 }, { "altitude": 210 }, { "altitude": 221 }, { "altitude": 232 }, { "altitude": 243 },] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.417054918021179, 37.775451543650483], [-122.416779418904284, 37.775703773323919], [-122.416761435324773, 37.775691130752165], [-122.416738605996017, 37.775713960080914], [-122.416669335469024, 37.775650570798277], [-122.416977015050549, 37.77540412098422], [-122.417041306306388, 37.775436266612139], [-122.417054918021179, 37.775451543650483]]] } }
        ]
    }
    public parkCentralHotel = {
        "type": "FeatureCollection",
        "name": "sql_statement",
        "units": "ft",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        "features": [
            { "type": "Feature", "properties": { "id": 1, "ground_altitude_hae": 0, "height_m": 34, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.40284, 37.786746], [-122.40302, 37.786749], [-122.403121, 37.786751], [-122.403223, 37.786751], [-122.403309, 37.786752], [-122.403331, 37.786753], [-122.403078, 37.786935], [-122.40284, 37.786746]]] } },


            { "type": "Feature", "properties": { "id": 2, "ground_altitude_hae": 0, "height_m": 34, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.402634, 37.786578], [-122.403116, 37.786186], [-122.403256, 37.786295], [-122.403586, 37.786551], [-122.403547, 37.786582], [-122.40332, 37.786579], [-122.403238, 37.786577], [-122.403128, 37.786575], [-122.402839, 37.786569], [-122.402634, 37.786578]]] } },

            { "type": "Feature", "properties": { "id": 3, "ground_altitude_hae": 0, "height_m": 155, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.402839, 37.786569], [-122.402735, 37.786656], [-122.402634, 37.786578], [-122.402839, 37.786569]]] } },

            { "type": "Feature", "properties": { "id": 4, "ground_altitude_hae": 0, "height_m": 155, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.403427, 37.786665], [-122.40332, 37.786579], [-122.403547, 37.786582], [-122.403427, 37.786665]]] } },

            { "type": "Feature", "properties": { "id": 5, "ground_altitude_hae": 0, "height_m": 364, "main": false, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }, { "altitude": 155 }, { "altitude": 166 }, { "altitude": 177 }, { "altitude": 188 }, { "altitude": 199 }, { "altitude": 210 }, { "altitude": 221 }, { "altitude": 232 }, { "altitude": 243 }, { "altitude": 254 }, { "altitude": 265 }, { "altitude": 276 }, { "altitude": 287 }, { "altitude": 298 }, { "altitude": 309 }, { "altitude": 320 }, { "altitude": 331 }, { "altitude": 342 }, { "altitude": 353 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.403223, 37.786751], [-122.403121, 37.786751], [-122.403124, 37.786681], [-122.403234, 37.786683], [-122.403238, 37.786577], [-122.40332, 37.786579], [-122.403427, 37.786665], [-122.403331, 37.786753], [-122.403309, 37.786752], [-122.40331, 37.786704], [-122.403224, 37.786703], [-122.403223, 37.786751]]] } },

            { "type": "Feature", "properties": { "id": 6, "ground_altitude_hae": 0, "height_m": 375, "main": true, "floors": [{ "altitude": 1 }, { "altitude": 12 }, { "altitude": 23 }, { "altitude": 34 }, { "altitude": 45 }, { "altitude": 56 }, { "altitude": 67 }, { "altitude": 78 }, { "altitude": 89 }, { "altitude": 100 }, { "altitude": 111 }, { "altitude": 122 }, { "altitude": 133 }, { "altitude": 144 }, { "altitude": 155 }, { "altitude": 166 }, { "altitude": 177 }, { "altitude": 188 }, { "altitude": 199 }, { "altitude": 210 }, { "altitude": 221 }, { "altitude": 232 }, { "altitude": 243 }, { "altitude": 254 }, { "altitude": 265 }, { "altitude": 276 }, { "altitude": 287 }, { "altitude": 298 }, { "altitude": 309 }, { "altitude": 320 }, { "altitude": 331 }, { "altitude": 342 }, { "altitude": 353 }, { "altitude": 364 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.40284, 37.786746], [-122.402735, 37.786656], [-122.402839, 37.786569], [-122.403128, 37.786575], [-122.403125, 37.786661], [-122.403023, 37.786659], [-122.40302, 37.786749], [-122.40284, 37.786746]]] } },

            { "type": "Feature", "properties": { "id": 7, "ground_altitude_hae": 0, "height_m": 390, "main": false, "floors": [{ "altitude": 1 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.403125, 37.786661], [-122.403124, 37.786681], [-122.403121, 37.786751], [-122.40302, 37.786749], [-122.403023, 37.786659], [-122.403125, 37.786661]]] } },
            { "type": "Feature", "properties": { "id": 8, "ground_altitude_hae": 0, "height_m": 390, "main": false, "floors": [{ "altitude": 1 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.403234, 37.786683], [-122.403124, 37.786681], [-122.403125, 37.786661], [-122.403128, 37.786575], [-122.403238, 37.786577], [-122.403234, 37.786683]]] } },
            { "type": "Feature", "properties": { "id": 9, "ground_altitude_hae": 0, "height_m": 381, "main": false, "floors": [{ "altitude": 1 }] }, "geometry": { "type": "MultiPolygon", "coordinates": [[[-122.403224, 37.786703], [-122.40331, 37.786704], [-122.403309, 37.786752], [-122.403223, 37.786751], [-122.403224, 37.786703]]] } }
        ]
    }

    public embassy_cords_user = [
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97850, lat: 37.38394, height: 20 },
        { lng: -121.97851, lat: 37.38395, height: 20 },
        { lng: -121.97853, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97857, lat: 37.38395, height: 20 },
        { lng: -121.97859, lat: 37.38395, height: 20 },
        { lng: -121.97861, lat: 37.38395, height: 20 },
        { lng: -121.97863, lat: 37.38395, height: 20 },
        { lng: -121.97865, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 28 },
        { lng: -121.97867, lat: 37.38395, height: 27 },
        { lng: -121.97867, lat: 37.38395, height: 26 },
        { lng: -121.97867, lat: 37.38395, height: 25 },
        { lng: -121.97867, lat: 37.38395, height: 24 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 21 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 19 },
        { lng: -121.97867, lat: 37.38395, height: 18.5 },
        { lng: -121.97867, lat: 37.38395, height: 18 },
        { lng: -121.97867, lat: 37.38395, height: 17.5 },
        { lng: -121.97867, lat: 37.38395, height: 17 },
        { lng: -121.97867, lat: 37.38395, height: 16.5 },
        { lng: -121.97867, lat: 37.38395, height: 16 },
        { lng: -121.97867, lat: 37.38395, height: 15.5 },
        { lng: -121.97867, lat: 37.38395, height: 15 },
        { lng: -121.97867, lat: 37.38395, height: 14.5 },
        { lng: -121.97867, lat: 37.38395, height: 14 },
        { lng: -121.97867, lat: 37.38395, height: 13.5 },
        { lng: -121.97867, lat: 37.38395, height: 13 },
        { lng: -121.97867, lat: 37.38395, height: 12.5 },
        { lng: -121.97867, lat: 37.38395, height: 12 },
        { lng: -121.97867, lat: 37.38395, height: 11.5 },
        { lng: -121.97867, lat: 37.38395, height: 11 },
        { lng: -121.97867, lat: 37.38395, height: 10.5 },
        { lng: -121.97867, lat: 37.38395, height: 10 },
        { lng: -121.97867, lat: 37.38395, height: 9 },
        { lng: -121.97867, lat: 37.38395, height: 8 },
        { lng: -121.97867, lat: 37.38395, height: 7 },
        { lng: -121.97867, lat: 37.38395, height: 6 },
        { lng: -121.97867, lat: 37.38395, height: 5 },
        { lng: -121.97867, lat: 37.38395, height: 4 },
        { lng: -121.97867, lat: 37.38395, height: 3 },
        { lng: -121.97867, lat: 37.38395, height: 2 },
        { lng: -121.97867, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38393, height: 1 },
        { lng: -121.97865, lat: 37.38391, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38388, height: 1 },
        { lng: -121.97870, lat: 37.38385, height: 1 },
        { lng: -121.97875, lat: 37.38385, height: 1 },
        { lng: -121.97880, lat: 37.38385, height: 1 },
        { lng: -121.97885, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 }
    ];
    public embassy_cords0 = [
        { lng: -121.97854, lat: 37.38367, height: 6 },
        { lng: -121.97854, lat: 37.38371, height: 6.5 },
        { lng: -121.97854, lat: 37.38375, height: 7 },
        { lng: -121.97854, lat: 37.38379, height: 7.5 },
        { lng: -121.97854, lat: 37.38383, height: 8 },
        { lng: -121.97854, lat: 37.38387, height: 8.5 },
        { lng: -121.97854, lat: 37.38391, height: 9 },
        { lng: -121.97854, lat: 37.38395, height: 9.5 },
        { lng: -121.97854, lat: 37.38399, height: 10 },
        { lng: -121.97854, lat: 37.38405, height: 10 },
        { lng: -121.97854, lat: 37.38410, height: 9.5 },
        { lng: -121.97854, lat: 37.38412, height: 9 },
        { lng: -121.97854, lat: 37.38414, height: 8.5 },
        { lng: -121.97854, lat: 37.38410, height: 8 },
        { lng: -121.97854, lat: 37.38405, height: 7.5 },
        { lng: -121.97854, lat: 37.38399, height: 7 },
        { lng: -121.97854, lat: 37.38396, height: 6 }
    ];

    public embassy_cords1 = [
        // { lng: -121.97915, lat: 37.38384, height: 1 },
        // { lng: -121.97910, lat: 37.38385, height: 1 },
        { lng: -121.97905, lat: 37.38385, height: 1 },
        { lng: -121.97900, lat: 37.38385, height: 1 },
        { lng: -121.97895, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97885, lat: 37.38385, height: 1 },
        { lng: -121.97880, lat: 37.38385, height: 1 },
        { lng: -121.97875, lat: 37.38385, height: 1 },
        { lng: -121.97870, lat: 37.38385, height: 1 },
        { lng: -121.97865, lat: 37.38385, height: 1 },
        { lng: -121.97865, lat: 37.38388, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38391, height: 1 },
        { lng: -121.97865, lat: 37.38393, height: 1 },
        { lng: -121.97865, lat: 37.38395, height: 1 },
        { lng: -121.97867, lat: 37.38395, height: 1.5 },
        { lng: -121.97867, lat: 37.38395, height: 2 },
        { lng: -121.97867, lat: 37.38395, height: 2.5 },
        { lng: -121.97867, lat: 37.38395, height: 3 },
        { lng: -121.97867, lat: 37.38395, height: 3.5 },
        { lng: -121.97867, lat: 37.38395, height: 4 },
        { lng: -121.97867, lat: 37.38395, height: 4.5 },
        { lng: -121.97867, lat: 37.38395, height: 5 },
        { lng: -121.97867, lat: 37.38395, height: 5.5 },
        { lng: -121.97867, lat: 37.38395, height: 6 },
        { lng: -121.97867, lat: 37.38395, height: 6.5 },
        { lng: -121.97867, lat: 37.38395, height: 7 },
        { lng: -121.97867, lat: 37.38395, height: 7.5 },
        { lng: -121.97867, lat: 37.38395, height: 8 },
        { lng: -121.97867, lat: 37.38395, height: 8.5 },
        { lng: -121.97867, lat: 37.38395, height: 9 },
        { lng: -121.97867, lat: 37.38395, height: 9.5 },
        { lng: -121.97867, lat: 37.38395, height: 10 },
        { lng: -121.97867, lat: 37.38395, height: 10.5 },
        { lng: -121.97867, lat: 37.38395, height: 11 },
        { lng: -121.97867, lat: 37.38395, height: 11.5 },
        { lng: -121.97867, lat: 37.38395, height: 12 },
        { lng: -121.97867, lat: 37.38395, height: 12.5 },
        { lng: -121.97867, lat: 37.38395, height: 13 },
        { lng: -121.97867, lat: 37.38395, height: 13.5 },
        { lng: -121.97867, lat: 37.38395, height: 14 },
        { lng: -121.97867, lat: 37.38395, height: 14.5 },
        { lng: -121.97867, lat: 37.38395, height: 15 },
        { lng: -121.97867, lat: 37.38395, height: 15.5 },
        { lng: -121.97867, lat: 37.38395, height: 16 },
        { lng: -121.97867, lat: 37.38395, height: 16.5 },
        { lng: -121.97867, lat: 37.38395, height: 17 },
        { lng: -121.97867, lat: 37.38395, height: 17.5 },
        { lng: -121.97867, lat: 37.38395, height: 18 },
        { lng: -121.97867, lat: 37.38395, height: 18.5 },
        { lng: -121.97867, lat: 37.38395, height: 19 },
        { lng: -121.97867, lat: 37.38395, height: 19.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20.5 },
        { lng: -121.97867, lat: 37.38395, height: 21 },
        { lng: -121.97867, lat: 37.38395, height: 21.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20.5 },
        { lng: -121.97867, lat: 37.38395, height: 23 },
        { lng: -121.97867, lat: 37.38395, height: 23.5 },
        { lng: -121.97867, lat: 37.38395, height: 24 },
        { lng: -121.97867, lat: 37.38395, height: 24.5 },
        { lng: -121.97867, lat: 37.38395, height: 25 },
        { lng: -121.97867, lat: 37.38395, height: 25.5 },
        { lng: -121.97867, lat: 37.38395, height: 26 },
        { lng: -121.97867, lat: 37.38395, height: 26.5 },
        { lng: -121.97867, lat: 37.38395, height: 27 },
        { lng: -121.97867, lat: 37.38395, height: 27.5 },
        { lng: -121.97867, lat: 37.38395, height: 28 },
        { lng: -121.97867, lat: 37.38395, height: 28.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97865, lat: 37.38395, height: 20 },
        { lng: -121.97863, lat: 37.38395, height: 20 },
        { lng: -121.97861, lat: 37.38395, height: 20 },
        { lng: -121.97859, lat: 37.38395, height: 20 },
        { lng: -121.97857, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97853, lat: 37.38395, height: 20 },
        { lng: -121.97852, lat: 37.38395, height: 20 },
        { lng: -121.97851, lat: 37.38395, height: 20 },
        { lng: -121.97853, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97857, lat: 37.38395, height: 20 },
        { lng: -121.97859, lat: 37.38395, height: 20 },
        { lng: -121.97861, lat: 37.38395, height: 20 },
        { lng: -121.97863, lat: 37.38395, height: 20 },
        { lng: -121.97865, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 28 },
        { lng: -121.97867, lat: 37.38395, height: 27 },
        { lng: -121.97867, lat: 37.38395, height: 26 },
        { lng: -121.97867, lat: 37.38395, height: 25 },
        { lng: -121.97867, lat: 37.38395, height: 24 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 21 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 19 },
        { lng: -121.97867, lat: 37.38395, height: 18.5 },
        { lng: -121.97867, lat: 37.38395, height: 18 },
        { lng: -121.97867, lat: 37.38395, height: 17.5 },
        { lng: -121.97867, lat: 37.38395, height: 17 },
        { lng: -121.97867, lat: 37.38395, height: 16.5 },
        { lng: -121.97867, lat: 37.38395, height: 16 },
        { lng: -121.97867, lat: 37.38395, height: 15.5 },
        { lng: -121.97867, lat: 37.38395, height: 15 },
        { lng: -121.97867, lat: 37.38395, height: 14.5 },
        { lng: -121.97867, lat: 37.38395, height: 14 },
        { lng: -121.97867, lat: 37.38395, height: 13.5 },
        { lng: -121.97867, lat: 37.38395, height: 13 },
        { lng: -121.97867, lat: 37.38395, height: 12.5 },
        { lng: -121.97867, lat: 37.38395, height: 12 },
        { lng: -121.97867, lat: 37.38395, height: 11.5 },
        { lng: -121.97867, lat: 37.38395, height: 11 },
        { lng: -121.97867, lat: 37.38395, height: 10.5 },
        { lng: -121.97867, lat: 37.38395, height: 10 },
        { lng: -121.97867, lat: 37.38395, height: 9 },
        { lng: -121.97867, lat: 37.38395, height: 8 },
        { lng: -121.97867, lat: 37.38395, height: 7 },
        { lng: -121.97867, lat: 37.38395, height: 6 },
        { lng: -121.97867, lat: 37.38395, height: 5 },
        { lng: -121.97867, lat: 37.38395, height: 4 },
        { lng: -121.97867, lat: 37.38395, height: 3 },
        { lng: -121.97867, lat: 37.38395, height: 2 },
        { lng: -121.97867, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38393, height: 1 },
        { lng: -121.97865, lat: 37.38391, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38388, height: 1 },
        { lng: -121.97870, lat: 37.38385, height: 1 },
        { lng: -121.97875, lat: 37.38385, height: 1 },
        { lng: -121.97880, lat: 37.38385, height: 1 },
        { lng: -121.97885, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97894, lat: 37.38385, height: 1 }
    ];
    public embassy_cords_firefighter = [
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97885, lat: 37.38385, height: 1 },
        { lng: -121.97880, lat: 37.38385, height: 1 },
        { lng: -121.97875, lat: 37.38385, height: 1 },
        { lng: -121.97870, lat: 37.38385, height: 1 },
        { lng: -121.97865, lat: 37.38385, height: 1 },
        { lng: -121.97865, lat: 37.38388, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38391, height: 1 },
        { lng: -121.97865, lat: 37.38393, height: 1 },
        { lng: -121.97865, lat: 37.38395, height: 1 },
        { lng: -121.97867, lat: 37.38395, height: 1.5 },
        { lng: -121.97867, lat: 37.38395, height: 2 },
        { lng: -121.97867, lat: 37.38395, height: 2.5 },
        { lng: -121.97867, lat: 37.38395, height: 3 },
        { lng: -121.97867, lat: 37.38395, height: 3.5 },
        { lng: -121.97867, lat: 37.38395, height: 4 },
        { lng: -121.97867, lat: 37.38395, height: 4.5 },
        { lng: -121.97867, lat: 37.38395, height: 5 },
        { lng: -121.97867, lat: 37.38395, height: 5.5 },
        { lng: -121.97867, lat: 37.38395, height: 6 },
        { lng: -121.97867, lat: 37.38395, height: 6.5 },
        { lng: -121.97867, lat: 37.38395, height: 7 },
        { lng: -121.97867, lat: 37.38395, height: 7.5 },
        { lng: -121.97867, lat: 37.38395, height: 8 },
        { lng: -121.97867, lat: 37.38395, height: 8.5 },
        { lng: -121.97867, lat: 37.38395, height: 9 },
        { lng: -121.97867, lat: 37.38395, height: 9.5 },
        { lng: -121.97867, lat: 37.38395, height: 10 },
        { lng: -121.97867, lat: 37.38395, height: 10.5 },
        { lng: -121.97867, lat: 37.38395, height: 11 },
        { lng: -121.97867, lat: 37.38395, height: 11.5 },
        { lng: -121.97867, lat: 37.38395, height: 12 },
        { lng: -121.97867, lat: 37.38395, height: 12.5 },
        { lng: -121.97867, lat: 37.38395, height: 13 },
        { lng: -121.97867, lat: 37.38395, height: 13.5 },
        { lng: -121.97867, lat: 37.38395, height: 14 },
        { lng: -121.97867, lat: 37.38395, height: 14.5 },
        { lng: -121.97867, lat: 37.38395, height: 15 },
        { lng: -121.97867, lat: 37.38395, height: 15.5 },
        { lng: -121.97867, lat: 37.38395, height: 16 },
        { lng: -121.97867, lat: 37.38395, height: 16.5 },
        { lng: -121.97867, lat: 37.38395, height: 17 },
        { lng: -121.97867, lat: 37.38395, height: 17.5 },
        { lng: -121.97867, lat: 37.38395, height: 18 },
        { lng: -121.97867, lat: 37.38395, height: 18.5 },
        { lng: -121.97867, lat: 37.38395, height: 19 },
        { lng: -121.97867, lat: 37.38395, height: 19.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20.5 },
        { lng: -121.97867, lat: 37.38395, height: 21 },
        { lng: -121.97867, lat: 37.38395, height: 21.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20.5 },
        { lng: -121.97867, lat: 37.38395, height: 23 },
        { lng: -121.97867, lat: 37.38395, height: 23.5 },
        { lng: -121.97867, lat: 37.38395, height: 24 },
        { lng: -121.97867, lat: 37.38395, height: 24.5 },
        { lng: -121.97867, lat: 37.38395, height: 25 },
        { lng: -121.97867, lat: 37.38395, height: 25.5 },
        { lng: -121.97867, lat: 37.38395, height: 26 },
        { lng: -121.97867, lat: 37.38395, height: 26.5 },
        { lng: -121.97867, lat: 37.38395, height: 27 },
        { lng: -121.97867, lat: 37.38395, height: 27.5 },
        { lng: -121.97867, lat: 37.38395, height: 28 },
        { lng: -121.97867, lat: 37.38395, height: 28.5 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97865, lat: 37.38395, height: 20 },
        { lng: -121.97863, lat: 37.38395, height: 20 },
        { lng: -121.97861, lat: 37.38395, height: 20 },
        { lng: -121.97859, lat: 37.38395, height: 20 },
        { lng: -121.97857, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97853, lat: 37.38395, height: 20 },
        { lng: -121.97852, lat: 37.38395, height: 20 },
        { lng: -121.97851, lat: 37.38395, height: 20 },
        { lng: -121.97853, lat: 37.38395, height: 20 },
        { lng: -121.97855, lat: 37.38395, height: 20 },
        { lng: -121.97857, lat: 37.38395, height: 20 },
        { lng: -121.97859, lat: 37.38395, height: 20 },
        { lng: -121.97861, lat: 37.38395, height: 20 },
        { lng: -121.97863, lat: 37.38395, height: 20 },
        { lng: -121.97865, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 28 },
        { lng: -121.97867, lat: 37.38395, height: 27 },
        { lng: -121.97867, lat: 37.38395, height: 26 },
        { lng: -121.97867, lat: 37.38395, height: 25 },
        { lng: -121.97867, lat: 37.38395, height: 24 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 21 },
        { lng: -121.97867, lat: 37.38395, height: 20 },
        { lng: -121.97867, lat: 37.38395, height: 19 },
        { lng: -121.97867, lat: 37.38395, height: 18.5 },
        { lng: -121.97867, lat: 37.38395, height: 18 },
        { lng: -121.97867, lat: 37.38395, height: 17.5 },
        { lng: -121.97867, lat: 37.38395, height: 17 },
        { lng: -121.97867, lat: 37.38395, height: 16.5 },
        { lng: -121.97867, lat: 37.38395, height: 16 },
        { lng: -121.97867, lat: 37.38395, height: 15.5 },
        { lng: -121.97867, lat: 37.38395, height: 15 },
        { lng: -121.97867, lat: 37.38395, height: 14.5 },
        { lng: -121.97867, lat: 37.38395, height: 14 },
        { lng: -121.97867, lat: 37.38395, height: 13.5 },
        { lng: -121.97867, lat: 37.38395, height: 13 },
        { lng: -121.97867, lat: 37.38395, height: 12.5 },
        { lng: -121.97867, lat: 37.38395, height: 12 },
        { lng: -121.97867, lat: 37.38395, height: 11.5 },
        { lng: -121.97867, lat: 37.38395, height: 11 },
        { lng: -121.97867, lat: 37.38395, height: 10.5 },
        { lng: -121.97867, lat: 37.38395, height: 10 },
        { lng: -121.97867, lat: 37.38395, height: 9 },
        { lng: -121.97867, lat: 37.38395, height: 8 },
        { lng: -121.97867, lat: 37.38395, height: 7 },
        { lng: -121.97867, lat: 37.38395, height: 6 },
        { lng: -121.97867, lat: 37.38395, height: 5 },
        { lng: -121.97867, lat: 37.38395, height: 4 },
        { lng: -121.97867, lat: 37.38395, height: 3 },
        { lng: -121.97867, lat: 37.38395, height: 2 },
        { lng: -121.97867, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38395, height: 1 },
        { lng: -121.97865, lat: 37.38393, height: 1 },
        { lng: -121.97865, lat: 37.38391, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38389, height: 1 },
        { lng: -121.97865, lat: 37.38388, height: 1 },
        { lng: -121.97870, lat: 37.38385, height: 1 },
        { lng: -121.97875, lat: 37.38385, height: 1 },
        { lng: -121.97880, lat: 37.38385, height: 1 },
        { lng: -121.97885, lat: 37.38385, height: 1 },
        { lng: -121.97890, lat: 37.38385, height: 1 },
        { lng: -121.97892, lat: 37.38385, height: 1 }
    ];
    public embassy_cords2 = [
        { lng: -121.97861, lat: 37.38413, height: 8 },
        { lng: -121.97860, lat: 37.38413, height: 8.5 },
        { lng: -121.97858, lat: 37.38413, height: 9 },
        { lng: -121.97856, lat: 37.38413, height: 9.5 },
        { lng: -121.97855, lat: 37.38413, height: 10 },
        { lng: -121.97853, lat: 37.38413, height: 10 },
        { lng: -121.97850, lat: 37.38413, height: 9.5 },
        { lng: -121.97847, lat: 37.38413, height: 9 },
        { lng: -121.97844, lat: 37.38413, height: 8.5 },
        { lng: -121.97841, lat: 37.38413, height: 8 },
        { lng: -121.97838, lat: 37.38413, height: 8 },
    ];
    // public anaheim_cords_user = [
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     },
    //     {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91950,
    //         lat: 33.80244,
    //         height: 21.5
    //     }, {
    //         lng: -117.91951,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91953,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91957,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91959,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91961,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91963,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80243,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80241,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80238,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80250,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80260,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80265,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80270,
    //         height: 1
    //     }, {
    //         lng: -117.91960,
    //         lat: 33.80275,
    //         height: 1
    //     }, {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }];

    // public anaheim_cords0 = [
    //     {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }, {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }, {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }, {
    //         lng: -117.91960,
    //         lat: 33.80275,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80270,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80265,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80260,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80250,
    //         height: 1
    //     },
    //     {
    //         lng: -117.91988,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91992,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91995,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80238,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80241,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80243,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 1.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91963,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91961,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91959,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91957,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91953,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91952,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91951,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91953,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91957,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91959,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91961,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91963,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80243,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80241,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80238,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91994,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80250,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80260,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80265,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80270,
    //         height: 1
    //     }, {
    //         lng: -117.91960,
    //         lat: 33.80275,
    //         height: 1
    //     }, {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }
    // ];
    // public anaheim_cords_firefighter = [
    //     {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }, {
    //         lng: -117.91960,
    //         lat: 33.80275,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80270,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80265,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80260,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80250,
    //         height: 1
    //     },
    //     {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80238,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80241,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80243,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 1.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91963,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91961,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91959,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91957,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91953,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91952,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91951,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91953,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91955,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91957,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91959,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91961,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91963,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 21
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 20
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 19
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 18
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 17
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 16
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 15
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 14
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 13
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 12
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 11
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10.5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 10
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 9
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 8
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 7
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 6
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 5
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 4
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 3
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 2
    //     }, {
    //         lng: -117.91967,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80243,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80241,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80239,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80238,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80235,
    //         height: 1
    //     }, {
    //         lng: -117.91990,
    //         lat: 33.80240,
    //         height: 1
    //     }, {
    //         lng: -117.91992,
    //         lat: 33.80245,
    //         height: 1
    //     }, {
    //         lng: -117.91985,
    //         lat: 33.80250,
    //         height: 1
    //     }, {
    //         lng: -117.91980,
    //         lat: 33.80255,
    //         height: 1
    //     }, {
    //         lng: -117.91975,
    //         lat: 33.80260,
    //         height: 1
    //     }, {
    //         lng: -117.91970,
    //         lat: 33.80265,
    //         height: 1
    //     }, {
    //         lng: -117.91965,
    //         lat: 33.80270,
    //         height: 1
    //     }, {
    //         lng: -117.91960,
    //         lat: 33.80275,
    //         height: 1
    //     }, {
    //         lng: -117.91956,
    //         lat: 33.80282,
    //         height: 1
    //     }];
    // public anaheim_cords1 = [{
    //     lng: -117.91954,
    //     lat: 33.80267,
    //     height: 6
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80271,
    //     height: 6.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80275,
    //     height: 7
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80279,
    //     height: 7.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80233,
    //     height: 8
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80237,
    //     height: 8.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80241,
    //     height: 9
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80245,
    //     height: 9.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80249,
    //     height: 10
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80205,
    //     height: 10
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80210,
    //     height: 9.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80212,
    //     height: 9
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80214,
    //     height: 8.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80210,
    //     height: 8
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80205,
    //     height: 7.5
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80249,
    //     height: 7
    // }, {
    //     lng: -117.91954,
    //     lat: 33.80246,
    //     height: 6
    // }];
    // public anaheim_cords2 = [{
    //     lng: -117.91961,
    //     lat: 33.80213,
    //     height: 8
    // }, {
    //     lng: -117.91960,
    //     lat: 33.80213,
    //     height: 8.5
    // }, {
    //     lng: -117.91958,
    //     lat: 33.80213,
    //     height: 9
    // }, {
    //     lng: -117.91956,
    //     lat: 33.80213,
    //     height: 9.5
    // }, {
    //     lng: -117.91955,
    //     lat: 33.80213,
    //     height: 10
    // }, {
    //     lng: -117.91953,
    //     lat: 33.80213,
    //     height: 10
    // }, {
    //     lng: -117.91950,
    //     lat: 33.80213,
    //     height: 9.5
    // }, {
    //     lng: -117.91947,
    //     lat: 33.80213,
    //     height: 9
    // }, {
    //     lng: -117.91944,
    //     lat: 33.80213,
    //     height: 8.5
    // }, {
    //     lng: -117.91941,
    //     lat: 33.80213,
    //     height: 8
    // }, {
    //     lng: -117.91937,
    //     lat: 33.80213,
    //     height: 8
    // }];
    public anaheim_cords_user = [
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 20
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 20
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 20
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 20
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 19.5
        },
        {
            lng: -117.91981,
            lat: 33.80239,
            height: 19.4
        },
        {
            lng: -117.91981,
            lat: 33.80239,
            height: 1.2
        },
        {
            lng: -117.91958,
            lat: 33.80283,
            height: 1.2
        }
    ];
    public anaheim_cords0 = [
        {
            lng: -117.91958,
            lat: 33.80283,
            height: 1
        },
        {
            lng: -117.91981,
            lat: 33.80239,
            height: 1
        },
        {
            lng: -117.91981,
            lat: 33.80239,
            height: 19.3
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 19.3
        },
        {
            lng: -117.91942,
            lat: 33.80233,
            height: 19.5
        }, {
            lng: -117.91983,
            lat: 33.80239,
            height: 19
        },
        {
            lng: -117.91983,
            lat: 33.80239,
            height: 1.4
        },
        {
            lng: -117.91960,
            lat: 33.80283,
            height: 1.4
        }];
    public anaheim_cords_firefighter = [
        {
            lng: -117.91955,
            lat: 33.80283,
            height: 2
        },
        {
            lng: -117.91978,
            lat: 33.80239,
            height: 2
        },
        {
            lng: -117.91978,
            lat: 33.80239,
            height: 19.5
        },
        {
            lng: -117.91939,
            lat: 33.80233,
            height: 19.5
        },
        {
            lng: -117.91939,
            lat: 33.80233,
            height: 19.5
        },
        {
            lng: -117.91978,
            lat: 33.80239,
            height: 19.5
        },
        {
            lng: -117.91978,
            lat: 33.80239,
            height: 1
        },
        {
            lng: -117.91955,
            lat: 33.80283,
            height: 1
        }];
    public park_central_cords0 = [
        { lng: -122.40338, lat: 37.78660, height: 10 },
        { lng: -122.40336, lat: 37.78658, height: 10 },
        { lng: -122.40333, lat: 37.78656, height: 10 },
        { lng: -122.40330, lat: 37.78653, height: 10 },
        { lng: -122.40328, lat: 37.78651, height: 10 },
        { lng: -122.40325, lat: 37.78649, height: 10 },
        { lng: -122.40320, lat: 37.78647, height: 10 },
        { lng: -122.40315, lat: 37.78644, height: 10 },
        { lng: -122.40310, lat: 37.78638, height: 10 },
        { lng: -122.40305, lat: 37.78635, height: 10 },
        { lng: -122.40300, lat: 37.78632, height: 10 }];

    public park_central_cords1 = [
        { lng: -122.40321, lat: 37.78649, height: 11 },
        { lng: -122.40321, lat: 37.78649, height: 14 },
        { lng: -122.40321, lat: 37.78649, height: 18 },
        { lng: -122.40321, lat: 37.78649, height: 20 },
        { lng: -122.40321, lat: 37.78649, height: 26 },
        { lng: -122.40321, lat: 37.78649, height: 30 },
        { lng: -122.40321, lat: 37.78649, height: 34 },
        { lng: -122.40321, lat: 37.78649, height: 38 },
        { lng: -122.40321, lat: 37.78649, height: 42 },
        { lng: -122.40321, lat: 37.78649, height: 44 },
        { lng: -122.40321, lat: 37.78649, height: 46 },
        { lng: -122.40321, lat: 37.78649, height: 50 },
        { lng: -122.40321, lat: 37.78649, height: 55 },
        { lng: -122.40321, lat: 37.78649, height: 60 },
        { lng: -122.40321, lat: 37.78649, height: 65 },
        { lng: -122.40321, lat: 37.78649, height: 70 },
        { lng: -122.40324, lat: 37.78646, height: 70 },
        { lng: -122.40327, lat: 37.78643, height: 70 },
        { lng: -122.40329, lat: 37.78640, height: 70 },
        { lng: -122.40334, lat: 37.78637, height: 70 },
        { lng: -122.40337, lat: 37.78634, height: 70 },
        { lng: -122.40335, lat: 37.78630, height: 70 },
        { lng: -122.40333, lat: 37.78633, height: 70 },
        { lng: -122.40330, lat: 37.78636, height: 70 },
        { lng: -122.40327, lat: 37.78638, height: 70 },
        { lng: -122.40324, lat: 37.78641, height: 70 },
        { lng: -122.40320, lat: 37.78644, height: 70 },
        { lng: -122.40318, lat: 37.78646, height: 70 },
        { lng: -122.40315, lat: 37.78649, height: 70 },
        { lng: -122.40321, lat: 37.78649, height: 70 },
        { lng: -122.40321, lat: 37.78649, height: 67 },
        { lng: -122.40321, lat: 37.78649, height: 63 },
        { lng: -122.40321, lat: 37.78649, height: 59 },
        { lng: -122.40321, lat: 37.78649, height: 55 }
    ];

    public park_central_cords2 = [
        { lng: -122.40309, lat: 37.78635, height: 10 },
        { lng: -122.40305, lat: 37.78637, height: 10 },
        { lng: -122.40302, lat: 37.78640, height: 10 },
        { lng: -122.40299, lat: 37.78643, height: 10 },
        { lng: -122.40296, lat: 37.78646, height: 10 },
        { lng: -122.40293, lat: 37.78649, height: 10 },
        { lng: -122.40290, lat: 37.78651, height: 10 },
        { lng: -122.40287, lat: 37.78653, height: 10 },
        { lng: -122.40284, lat: 37.78655, height: 10 },
        { lng: -122.40281, lat: 37.78657, height: 10 },
        { lng: -122.40278, lat: 37.78658, height: 10 },
    ];


    public cords0 = [
        { lng: -122.39487, lat: 37.79364, height: 10 },
        { lng: -122.39486, lat: 37.79375, height: 10 },
        { lng: -122.39483, lat: 37.79376, height: 10 },
        { lng: -122.39481, lat: 37.79378, height: 10 },
        { lng: -122.39478, lat: 37.79370, height: 10 },
        { lng: -122.39475, lat: 37.79373, height: 10 },
        { lng: -122.39470, lat: 37.79375, height: 10 },
        { lng: -122.39465, lat: 37.79378, height: 10 },
        { lng: -122.39460, lat: 37.79381, height: 10 },
        { lng: -122.40321, lat: 37.79387, height: 10 },
        { lng: -122.39450, lat: 37.79394, height: 10 }];

    public cords1 = [
        { lng: -122.39455, lat: 37.79334, height: 11 },
        { lng: -122.39455, lat: 37.79334, height: 14 },
        { lng: -122.39455, lat: 37.79334, height: 18 },
        { lng: -122.39455, lat: 37.79334, height: 20 },
        { lng: -122.39455, lat: 37.79334, height: 26 },
        { lng: -122.39455, lat: 37.79334, height: 30 },
        { lng: -122.39455, lat: 37.79334, height: 34 },
        { lng: -122.39455, lat: 37.79334, height: 38 },
        { lng: -122.39455, lat: 37.79334, height: 42 },
        { lng: -122.39455, lat: 37.79334, height: 44 },
        { lng: -122.39455, lat: 37.79334, height: 46 },
        { lng: -122.39455, lat: 37.79334, height: 50 },
        { lng: -122.39455, lat: 37.79334, height: 55 },
        { lng: -122.39455, lat: 37.79334, height: 60 },
        { lng: -122.39455, lat: 37.79334, height: 65 },
        { lng: -122.39455, lat: 37.79334, height: 70 },
        { lng: -122.39450, lat: 37.79330, height: 70 },
        { lng: -122.39445, lat: 37.79326, height: 70 },
        { lng: -122.39440, lat: 37.79322, height: 70 },
        { lng: -122.39433, lat: 37.79319, height: 70 },
        { lng: -122.39440, lat: 37.79322, height: 70 },
        { lng: -122.39445, lat: 37.79326, height: 70 },
        { lng: -122.39450, lat: 37.79330, height: 70 },
        { lng: -122.39455, lat: 37.79334, height: 70 },
        { lng: -122.39458, lat: 37.79336, height: 70 },
        { lng: -122.39461, lat: 37.79338, height: 70 },
        { lng: -122.39463, lat: 37.79339, height: 70 },
        { lng: -122.39461, lat: 37.79338, height: 70 },
        { lng: -122.39458, lat: 37.79336, height: 70 },
        { lng: -122.39455, lat: 37.79334, height: 70 },
        { lng: -122.39455, lat: 37.79334, height: 67 },
        { lng: -122.39455, lat: 37.79334, height: 63 },
        { lng: -122.39455, lat: 37.79334, height: 59 },
        { lng: -122.39455, lat: 37.79334, height: 55 }
    ];

    public cords2 = [
        { lng: -122.39466, lat: 37.79370, height: 10 },
        { lng: -122.39458, lat: 37.79365, height: 10 },
        { lng: -122.39450, lat: 37.79360, height: 10 },
        { lng: -122.39442, lat: 37.79355, height: 10 },
        { lng: -122.39436, lat: 37.79350, height: 10 },
        { lng: -122.39428, lat: 37.79345, height: 10 },
        { lng: -122.39420, lat: 37.79340, height: 10 },
        { lng: -122.39412, lat: 37.79335, height: 10 },
        { lng: -122.39404, lat: 37.79330, height: 10 },
        { lng: -122.39394, lat: 37.79325, height: 10 },
        { lng: -122.39386, lat: 37.79320, height: 10 },
    ];
    public cords3 = [
        { lng: -122.41835, lat: 37.75528, height: 5 },
        { lng: -122.41835, lat: 37.75528, height: 7 },
        { lng: -122.41835, lat: 37.75528, height: 9 },
        { lng: -122.41835, lat: 37.75528, height: 11 },
        { lng: -122.41835, lat: 37.75528, height: 14 },
        { lng: -122.41835, lat: 37.75528, height: 16 },
        { lng: -122.41835, lat: 37.75528, height: 18 },
        { lng: -122.41835, lat: 37.75528, height: 20 },
        { lng: -122.41835, lat: 37.75528, height: 20 },
        { lng: -122.41835, lat: 37.75528, height: 20 },
        { lng: -122.41835, lat: 37.75528, height: 18 },
        { lng: -122.41835, lat: 37.75528, height: 18 },
        { lng: -122.41837, lat: 37.75524, height: 18 },
        { lng: -122.41832, lat: 37.75526, height: 18 },
        { lng: -122.41827, lat: 37.75528, height: 18 },
        { lng: -122.41822, lat: 37.75530, height: 18 },
        { lng: -122.41827, lat: 37.75528, height: 18 },
        { lng: -122.41832, lat: 37.75526, height: 18 },
        { lng: -122.41837, lat: 37.75524, height: 18 },
        { lng: -122.41842, lat: 37.75522, height: 18 },
        { lng: -122.41845, lat: 37.75524, height: 18 },
        { lng: -122.41848, lat: 37.75525, height: 18 },
        { lng: -122.41849, lat: 37.75527, height: 18 },
        { lng: -122.41848, lat: 37.75525, height: 18 },
        { lng: -122.41845, lat: 37.75524, height: 18 },
    ];

    public cords4 = [
        { lng: -122.41818, lat: 37.75522, height: 20 },
        { lng: -122.41822, lat: 37.75522, height: 20 },
        { lng: -122.41826, lat: 37.75522, height: 20 },
        { lng: -122.41830, lat: 37.75522, height: 20 },
        { lng: -122.41834, lat: 37.75522, height: 20 },
        { lng: -122.41838, lat: 37.75522, height: 20 },
        { lng: -122.41842, lat: 37.75522, height: 20 },
        { lng: -122.41846, lat: 37.75522, height: 20 },
        { lng: -122.41850, lat: 37.75522, height: 20 },
        { lng: -122.41853, lat: 37.75522, height: 20 },
        { lng: -122.41855, lat: 37.75522, height: 20 },
        { lng: -122.41853, lat: 37.75522, height: 20 },
        { lng: -122.41850, lat: 37.75522, height: 20 },
        { lng: -122.41846, lat: 37.75522, height: 20 },
        { lng: -122.41842, lat: 37.75522, height: 20 }
    ]


    timeStepInSeconds = 1;
    uid: string='';
    channelId: string='';
    clear: any = [];
    viewer: any;
    currentUserPositionProperty: any;
    currentLatLong: { lat: any; long: any; };
    currentUserHeight: number=0;
    interval: number=0;
    position: any;
    isLocationUserPinned: boolean=false;

    constructor(private http: HttpClient, private pubnub: PubnubService) {
        this.position = {};
        this.currentLatLong = {
            lat: null,
            long: null
        }
    }

    setCurrentLatLong(lat:number, long:number) {
        this.currentLatLong = {
            lat: lat,
            long: long
        }
    }
    setUserPinnedStatus(isLocationUserPinned:boolean) {
        this.isLocationUserPinned = isLocationUserPinned;
    }
    setUserHeight(height: number) {
        this.currentUserHeight = height;
    }

    addSimulation(dataPoint:any, positionProperty:any, viewer:any) {
        const time = Cesium.JulianDate.addSeconds(viewer.clock.currentTime, this.timeStepInSeconds, new Cesium.JulianDate());
        if (dataPoint && dataPoint.location2d && dataPoint.location2d.latitude && dataPoint.location2d.longitude) {
            dataPoint.heightAboveTerrain = dataPoint.heightAboveTerrain ? dataPoint.heightAboveTerrain : 0;
            if (isFinite(dataPoint.location2d.latitude) && Math.abs(dataPoint.location2d.latitude) <= 90 && Math.abs(dataPoint.location2d.longitude) <= 180 && Math.abs(dataPoint.location2d.longitude) <= 180 && isFinite(dataPoint.heightAboveTerrain)) {
                const position = Cesium.Cartesian3.fromDegrees(dataPoint.location2d.longitude, dataPoint.location2d.latitude, dataPoint.heightAboveTerrain);
                positionProperty.addSample(time, position);
                // positionProperty.entity.point.outlineColor = dataPoint.isLocationUserPinned ? Cesium.Color.RED : Cesium.Color.CORNFLOWERBLUE;
                // if (positionProperty.entity.name == 'heightLabel')
                //   positionProperty.entity.label.text = Math.floor(Number(dataPoint.heightAboveTerrain * 3.28084)).toString() + " ft"
            }
            else console.log("datapoint not correct", dataPoint);
        }
        else console.log("datapoint not correct", dataPoint);
    }

    async editPositionProperty(viewer:any, PositionProperty:any, initials = "", userType = null) {
        if (PositionProperty.entity.label)
            PositionProperty.entity.label.text = initials;
        if (PositionProperty.entity.billboard) {
            let img = null;
            if (userType == 2)
                img = './assets/police.png';
            else if (userType == 1)
                img = './assets/firefighter.png';
            else if (userType == 3)
                img = './assets/ems.png';
            else if (userType == 4)
                img = './assets/security.png';
            else if (userType == 5)
                img ='./assets/e911caller.png';// await this.svgToDataURL(this.createSVGIconWithText(""));
            PositionProperty.entity.billboard.image = img;
        }
        return PositionProperty;
    }

    deletePositionProperty(viewer:any, PositionProperty:any) {
        viewer.entities.remove(PositionProperty.entity);
    }

    async createPositionProperty(viewer:any, isCurrentUser = false, initials = "", pinnedUser:any, userType = null) {
        let PositionProperty = new Cesium.SampledPositionProperty();
        let name;
        if (isCurrentUser) {
            name = 0;
            if (this.currentUserPositionProperty) {
                this.clearInt();
                this.deletePositionProperty(viewer, this.currentUserPositionProperty);
                this.currentUserPositionProperty = null;
            }
        }
        else
            name = initials;

        await this.addEntityToViewer(viewer, PositionProperty, name, null, pinnedUser, userType).then(function (returnVal) {
            PositionProperty.entity = returnVal;
            PositionProperty.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;              
        }).catch(function(e){
            console.log("got an error",e);
            throw e; // rethrow to not marked as handled, 
         });
        return PositionProperty;          
    }

    async addEntityToViewer(viewer:any, PositionProperty:any, name:any, img:any, isUserPinned:any, userType:any) {
        if (name == 0) {
            var backCircle = new Cesium.Entity({
                name: 'icon',
                availability: undefined,
                position: PositionProperty,
                point: {
                    pixelSize: 13,
                    color: Cesium.Color.WHITE,
                    outlineColor: isUserPinned ? Cesium.Color.RED : Cesium.Color.CORNFLOWERBLUE,
                    outlineWidth: 1,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7)
                }
            });
            var frontCircle = new Cesium.Entity({
                name: 'icon',
                availability: undefined,
                position: PositionProperty,
                pixelOffset: new Cesium.Cartesian2(0, 10),
                point: {
                    pixelSize: 6,
                    color: isUserPinned ? Cesium.Color.RED : Cesium.Color.CORNFLOWERBLUE,// Cesium.Color.ROYALBLUE,
                    // outlineColor: Cesium.Color.CORNFLOWERBLUE,
                    //outlineWidth: 1,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7)
                }
            });
            viewer.entities.add(backCircle);
            viewer.entities.add(frontCircle);
            return backCircle;
        }
        else if (userType) {
            var propertyBag = new Cesium.PropertyBag();
            propertyBag.addProperty('initials', name);
            // var backCircle = new Cesium.Entity({
            //   availability: undefined,
            //   position: PositionProperty,
            //   point: {
            //     pixelSize: 13,
            //     color: Cesium.Color.WHITE,
            //     outlineColor: isUserPinned ? Cesium.Color.RED : Cesium.Color.CORNFLOWERBLUE,
            //     outlineWidth: 1,
            //     scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7)
            //   }
            // });       
            if (userType == 2)
                img = './assets/police.png';
            else if (userType == 1)
                img = './assets/firefighter.png';
            else if (userType == 3)
                img = './assets/ems.png';
            else if (userType == 4)
                img = './assets/security.png';
            else if (userType == 5)
                img = './assets/e911caller.png';//await this.svgToDataURL(this.createSVGIconWithText(""));
            var imgEntity = new Cesium.Entity({
                name: 'icon',
                position: PositionProperty,
                point: {
                    pixelSize: 17,
                    color: Cesium.Color.TRANSPARENT,
                    outlineColor: isUserPinned ? Cesium.Color.RED : Cesium.Color.BLACK,
                    // outlineColor: isUserPinned ? Cesium.Color.RED : Cesium.Color.CORNFLOWERBLUE,
                    outlineWidth: 1,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7),
                },
                properties: propertyBag,
                billboard: {
                    image: img,
                    width: 32,
                    height: 32,
                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                    pixelOffset: new Cesium.Cartesian2(0, 0)
                },
                // label: {
                //     text: name,
                //     font: "100px Helvetica",
                //     fillColor: Cesium.Color.BLACK,
                //     outlineColor: Cesium.Color.WHITE,
                //     outlineWidth: 1,
                //     style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                //     scale: 0.15,
                //     eyeOffset: new Cesium.Cartesian3(0, 0, -0.1),
                //     pixelOffset: new Cesium.Cartesian2(0, 13),
                //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                //     scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e4, 1),
                //     disableDepthTestDistance: Number.POSITIVE_INFINITY
                // }
            });
            viewer.entities.add(imgEntity);
            return imgEntity;
        }
        else {
            var backCircle = new Cesium.Entity({
                name: 'icon',
                availability: undefined,
                position: PositionProperty,
                point: {
                    pixelSize: 15,
                    color: Cesium.Color.BLACK,
                    outlineColor: Cesium.Color.WHITE,
                    outlineWidth: 1,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7)
                },
                label: {
                    text: name,
                    font: "100px Helvetica",
                    fillColor: Cesium.Color.WHITE,
                    outlineColor: Cesium.Color.WHITE,
                    outlineWidth: 1,
                    style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                    scale: 0.1,
                    eyeOffset: new Cesium.Cartesian3(0, 0, -0.1),
                    pixelOffset: new Cesium.Cartesian2(0, 8),
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e4, 1)
                },
                orientation: new Cesium.VelocityOrientationProperty(PositionProperty)
            });

            var frontCircle = new Cesium.Entity({
                name: 'icon',
                availability: undefined,// new Cesium.TimeIntervalCollection([new Cesium.TimeInterval({ start: start, stop: stop })]),
                position: PositionProperty,// new Cesium.CallbackProperty(getPosition, false),
                point: {
                    pixelSize: 14,
                    color: Cesium.Color.WHITE,
                    outlineColor: isUserPinned ? Cesium.Color.RED : Cesium.Color.BLACK,
                    outlineWidth: 1,
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 1.7)
                },
                label: {
                    // disableDepthTestDistance: Number.POSITIVE_INFINITY,
                    text: name,
                    font: "12px Verdana",
                    fillColor: Cesium.Color.BLACK,
                    outlineColor: Cesium.Color.BLACK,//.CORNFLOWERBLUE,
                    outlineWidth: 1,
                    style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                    scale: 1,
                    eyeOffset: new Cesium.Cartesian3(0, 0, -0.1),
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e4, 1)
                    // pixelOffset: new Cesium.Cartesian2(0, -9),
                    //showBackground : true,
                    //horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
                    // verticalOrigin: Cesium.VerticalOrigin.TOP,
                    // scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.7, 1.5e4, 0.5)
                },
                orientation: new Cesium.VelocityOrientationProperty(PositionProperty)
            });
            // viewer.entities.add(backCircle);
            viewer.entities.add(frontCircle);
            return frontCircle;
        }
    }
    setViewer(viewer:any) {
        this.viewer = viewer;
    }

    getCurrentPosition(viewer:any, userPinned:any, userType = null) {
        this.viewer = viewer;
        if (!this.currentUserPositionProperty) {
            this.currentUserPositionProperty = this.createPositionProperty(viewer, true, "", userPinned, userType);
        }
        if (navigator.geolocation) {
            this.interval = window.setInterval(() => {
                navigator.geolocation.getCurrentPosition(this.setCurrentPosition, this.errorInLocation);
                if (userPinned) this.clearInt();
            }, 2000);
        } else {
            this.errorInLocation("error");
        }
    }

    errorInLocation = (error:any) => {
        console.log("user location not allowed");
        this.clearInt();
        if (this.currentLatLong.lat && this.currentLatLong.long) {
            let position = {
                coords: {
                    latitude: this.currentLatLong.lat,
                    longitude: this.currentLatLong.long
                }
            }
            this.setCurrentPosition(position);
        }
        else console.log("also not received from device");
    }

    setCurrentPosition = (position:any) => {
        if (position.coords.latitude) {
            this.currentLatLong = {
                lat: position.coords.latitude,
                long: position.coords.longitude
            }
            this.addCurrentUserDataPoint(this.viewer);
            // console.log("userLat long allowed", this.currentLatLong.lat, this.currentLatLong);
        }
        else this.clearInt();
    }

    clearInt() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }

    addCurrentUserDataPoint(viewer:any) {
        let datapoint = {
            heightUncertainty: 5,
            heightAboveTerrain: 5,
            isLocationUserPinned: this.isLocationUserPinned,
            location2d: {
                uncertainty: 0,
                longitude: this.currentLatLong.long,
                latitude: this.currentLatLong.lat
            },
            height: 5,
            heightAboveTerrainUncertainty: 0,
        }
        if (this.currentUserHeight) {
            datapoint.heightAboveTerrain = this.currentUserHeight;
            datapoint.height = this.currentUserHeight;
        }
        if (datapoint.location2d.longitude && this.currentUserPositionProperty && viewer) {
            this.addSimulation(datapoint, this.currentUserPositionProperty, viewer);
        }
    }

    setUID(uid:any, channelId:any) {
        this.uid = uid;
        this.channelId = channelId;
        //this.publishForTest(uid);
    }

    clearAllTimeout() {
        for (var i = 0; i < this.clear.length; i++) {
            clearTimeout(this.clear[i]);
        }
    }
    createSVGIcon(text:any) {
        if (text == "")
            return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="4" fill="#5EB2E1" stroke="#5EB2E1" stroke-width="1"/>
</svg>
`;
        else return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
    }
    createSVGIconWithText(text:any) {
        if (text == "")
            return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#ffffff" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
</svg>
`;
        else return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
    }

    svgToDataURL(svg:any) {
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    }

    async createSVGIconWithTextForAltimeter(img:any, text:any) {
        if (img == "") {
            let svg = `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
            return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
        }
        else {
            let svg = `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
            let x = await mergeImages([{ 'src': `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`, x: 0, y: 0 }])
                .then((b64:any) => b64).catch(function(e:any){
                    console.log("got an error",e);
                    throw e; // rethrow to not marked as handled, 
                 });
            return x;
        }
    }



    async publishForTest(altimeterChart:any, bldg:any) {
        if (bldg == 'embassy') {
            // this.demoSimulation(this.embassy_cords_user, 'ID1', "UU", null, 5);
            // this.demoSimulation(this.embassy_cords0, 'ID3', "U2", null);
            // this.demoSimulation(this.embassy_cords1, 'Cop', "PP", './assets/police.png', 2);
            // this.demoSimulation(this.embassy_cords2, 'Caller', "U1", null);
            // this.demoSimulation(this.embassy_cords_firefighter, 'Firefighter', "FY", './assets/firefighter.png', 1);
            // altimeterChart.addDevices1([
            //     { id: "ID1", icon: this.svgToDataURL(this.createSVGIconWithText("")) },
            //     { id: "Caller", icon: this.svgToDataURL(this.createSVGIconWithText("DJ")) },
            //     { id: "ID3", icon: this.svgToDataURL(this.createSVGIconWithText("U2")) },
            //     { id: "Cop", icon: this.svgToDataURL(this.createSVGIconWithText("PP")) },
            //     { id: "Firefighter", icon: this.svgToDataURL(this.createSVGIconWithText("FY")) }
            // ]
            // );
        }
        else if (bldg == 'anaheim') {
            this.demoSimulation(this.anaheim_cords_user, 'Kevin', "Kevin", './assets/e911caller.png', 5);
            this.demoSimulation(this.anaheim_cords0, 'James', "James", './assets/police.png', 2);
            this.demoSimulation(this.anaheim_cords_firefighter, 'David', "David", './assets/firefighter.png', 1);
            altimeterChart.addDevices1([

                { id: "Kevin", icon: this.svgToDataURL(this.createSVGIconWithText("")) },
                { id: "James", icon: './assets/police.png' },
                { id: "David", icon: './assets/firefighter.png' },
                // { id: "Caller",  icon: await this.createSVGIconWithTextForAltimeter('',"DJ") },
                // { id: "Cop", icon: await this.createSVGIconWithTextForAltimeter('./assets/police.png',"FY") },
                // { id: "Firefighter", icon: await this.createSVGIconWithTextForAltimeter('./assets/firefighter.png',"JZ") }
            ]
            );
        }
        return this.posProperties1;
        // altimeterChart.updateDevice({
        //   id: 'ID1',
        //   latitude: '89',
        //   longitude: '20',
        //   hae: '',
        //   hat: 10
        // });
        // altimeterChart.updateDevice({
        //   id: 'ID2',
        //   latitude: '89',
        //   longitude: '20',
        //   hae: '',
        //   hat: 20
        // });
        // altimeterChart.updateDevice({
        //   id: 'ID3',
        //   latitude: '89',
        //   longitude: '20',
        //   hae: '',
        //   hat: 30
        // });
    }
    posProperties1: any = [];
    demoSimulation(coords:any, uid:any, name:any, img:any, userType:number = 0) {
        let position = { uid: '', pp: null };
        var posProperty = new Cesium.SampledPositionProperty();
        let delay = 10;
        let sec = 0;
        for (let i = 0; i < coords.length; i++) {
            if (i == 0) delay = 0;
            else if (i == 4) delay = 2; else delay = 7;
            const dataPoint = coords[i];
            const time = Cesium.JulianDate.addSeconds(this.viewer.clock.startTime, sec + delay, new Cesium.JulianDate());
            const position = Cesium.Cartesian3.fromDegrees(dataPoint.lng, dataPoint.lat, dataPoint.height);
            posProperty.addSample(time, position);
            sec = sec + delay;
        }
        posProperty.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
        this.addEntityToViewer(this.viewer, posProperty, name, img, false, userType);
        position['uid'] = uid;
        position['pp'] = posProperty;
        this.posProperties1.push(position);
    }  

    globalHandler(error: HttpErrorResponse) {
        return throwError(error.message || 'Server Error');
    }

    errorHandler(error: any | any) {
        console.log(error.error || error.json() || error);
        return throwError(
            error.error || error.json() || error || 'Server error'
        );
    }
}